export const THRESHOLDS_OVERTIME_REQUEST = 'THRESHOLDS_OVERTIME_REQUEST';
export const THRESHOLDS_OVERTIME = 'THRESHOLDS_OVERTIME';
export const FETCH_CURRENT_HEALTH_REQUEST = 'FETCH_CURRENT_HEALTH_REQUEST';
export const FETCH_CURRENT_HEALTH = 'FETCH_CURRENT_HEALTH';
export const FETCH_HEALTH_HISTORY_REQUEST = 'FETCH_HEALTH_HISTORY_REQUEST';
export const FETCH_HEALTH_HISTORY = 'FETCH_HEALTH_HISTORY';
export const FETCH_HEALTH_THRESHOLDS_REQUEST = 'FETCH_HEALTH_THRESHOLDS_REQUEST';
export const FETCH_HEALTH_THRESHOLDS = 'FETCH_HEALTH_THRESHOLDS';